// Helper function for removing facet values from URL (used by both resource and event filter terms)
function removeFacetValueFromUrl(facet, value) {
    const key = `_${facet}`;
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (!params.has(key)) return false;

    const current = params.get(key);
    if (!current) return false;

    // Helper to normalize values for comparison
    function norm(x) {
        try { return decodeURIComponent(String(x)).trim().toLowerCase(); }
        catch { return String(x).trim().toLowerCase(); }
    }

    // Comma-separated values
    const parts = current.split(',').filter(s => s !== '');
    const filtered = parts.filter(v => norm(v) !== norm(value));

    if (filtered.length === parts.length) {
        return false; // no change
    }

    if (filtered.length > 0) {
        params.set(key, filtered.join(','));
    } else {
        params.delete(key);
    }

    // Also clear paging so you don't land on an empty page
    params.delete('fwp_paged');
    params.delete('paged');

    url.search = params.toString();
    window.location.href = url.toString(); // navigate with only this one value removed
    return true;
}

function init() {
    // Set default event_status to "upcoming" on initial page load if not set
    // This is a visual fallback - PHP filter handles the actual default
    function setDefaultEventStatusVisual() {
        // Check URL params first - if event_status is in URL, don't override
        const urlParams = new URLSearchParams(window.location.search);
        const eventStatusParam = urlParams.get('_event_status');
        
        // Only set default visually if not in URL params
        if (!eventStatusParam) {
            // Find the event_status radio facet
            const eventStatusFacet = document.querySelector('.facetwp-facet-event_status');
            if (eventStatusFacet) {
                // Check if any radio is already selected
                const checkedRadio = eventStatusFacet.querySelector('.facetwp-radio.checked');
                if (!checkedRadio) {
                    // Find the "upcoming" radio button and select it
                    const upcomingRadio = eventStatusFacet.querySelector('.facetwp-radio[data-value="upcoming"]');
                    if (upcomingRadio && !upcomingRadio.classList.contains('disabled')) {
                        // Set FWP.facets if available
                        if (typeof FWP !== 'undefined' && typeof FWP.facets !== 'undefined') {
                            FWP.facets.event_status = ['upcoming'];
                        }
                        // Visually select it
                        upcomingRadio.classList.add('checked');
                        // Trigger FacetWP refresh
                        if (typeof FWP !== 'undefined' && typeof FWP.autoload === 'function') {
                            FWP.autoload();
                        }
                    }
                }
            }
        }
    }
    
    // Wait for FacetWP to be ready, then set default
    document.addEventListener('facetwp-loaded', function() {
        setDefaultEventStatusVisual();
    }, { once: true });

    document.addEventListener('facetwp-loaded', function () {
        // Reset auto_refresh to true on each load
        FWP.auto_refresh = true;

        // Make FacetWP checkboxes accessible and disable auto-refresh
        document.querySelectorAll('.facetwp-type-checkboxes .facetwp-checkbox').forEach(function (checkboxDiv) {
            // Make div focusable and add ARIA attributes
            checkboxDiv.setAttribute('tabindex', '0');
            checkboxDiv.setAttribute('role', 'checkbox');

            // Get the current checked state
            const isChecked = checkboxDiv.classList.contains('checked');
            checkboxDiv.setAttribute('aria-checked', isChecked);
            // Handle click events
            checkboxDiv.addEventListener('click', function () {
                // Don't disable auto_refresh if this checkbox is inside .event-listings
                if (!checkboxDiv.closest('.event-listings')) {
                    FWP.auto_refresh = false;
                }
            });

            // Handle keyboard events
            checkboxDiv.addEventListener('keydown', function (e) {
                // Handle Enter and Space keys
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    // Toggle the checkbox
                    checkboxDiv.click();
                    // Update aria-checked attribute
                    const newCheckedState = checkboxDiv.classList.contains('checked');
                    checkboxDiv.setAttribute('aria-checked', newCheckedState);
                }
            });
        });

        // Replace icon with search button
        document.querySelectorAll('.facetwp-type-search').forEach(function (facet) {
            const icon = facet.querySelector('i.facetwp-icon');
            if (icon) {
                icon.remove();
                const button = document.createElement('button');
                button.className = 'facetwp-search-button';
                button.type = 'button';
                button.textContent = 'Search';
                facet.appendChild(button);

                button.addEventListener('click', function () {
                    FWP.refresh();
                });
            }
        });

        // Apply filters button triggers refresh and reenables auto refresh
        document.getElementById('applyFilters')?.addEventListener('click', function (e) {
            e.preventDefault();
            FWP.auto_refresh = true;
            FWP.refresh();

            // jQuery: Hide the filter section
            jQuery('#resourceFilters').slideUp(300);
        });

        // --- jQuery toggle for Filter By ---
        jQuery(function ($) {
            const $filterBy = $('#filterBy');
            const $resourceFilters = $('#resourceFilters');
            const $applyFilters = $('#applyFilters');
            const $resetButtons = $('.facetwp-reset');

            // Hide initially and set state
            $resourceFilters.hide().attr('data-open', 'false');

            $filterBy.off('click').on('click', function (e) {
                e.preventDefault();

                const isOpen = $resourceFilters.attr('data-open') === 'true';

                if (isOpen) {
                    $resourceFilters.stop(true, true).slideUp(300).attr('data-open', 'false');
                } else {
                    $resourceFilters.stop(true, true).slideDown(300).attr('data-open', 'true');
                }
            });

            $applyFilters.off('click').on('click', function (e) {
                $resourceFilters.stop(true, true).slideUp(300).attr('data-open', 'false');
            });

            $resetButtons.off('click').on('click', function () {
                $resourceFilters.stop(true, true).slideUp(300).attr('data-open', 'false');
            });
        });

        // --- end jQuery toggle ---

        // Clear previous filter terms
        const filterContainer = document.getElementById('resourceFilterTerms');
        const filterWrapper = filterContainer?.closest('.facet-clear-wrapper');

        if (filterContainer) {
            filterContainer.innerHTML = ''; // Reset contents
        }

        // Track whether any filters are applied
        let filtersFound = false;

        const getFacetDisplayLabel = (facet, value) => {
            const checkboxDiv = document.querySelector(
                `.facetwp-facet-${facet} .facetwp-checkbox[data-value="${value}"]`
            );
            const displaySpan = checkboxDiv?.querySelector('.facetwp-display-value');

            if (displaySpan) {
                const text = displaySpan.textContent?.trim();
                if (text) {
                    return text;
                }
            }

            return value
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        };

        // List of checkbox facets to check
        let checkboxFacets = [];

        if (document.body.classList.contains('post-type-archive-resource')) { // resource library
            checkboxFacets = ['resource_type', 'resource_topic', 'resource_product'];
        }
        else if (document.body.classList.contains('blog')) { // blog archive
            checkboxFacets = ['blog_topics', 'blog_author', 'resource_product', 'blog_tag'];

            // change search placeholder text for blog archive
            const searchInput = document.querySelector('.facetwp-search');
            if (searchInput) {
                searchInput.placeholder = 'Search for posts..';
            }
        }

        // removeFacetValueFromUrl is now defined at module level above

        checkboxFacets.forEach(facet => {
            const values = FWP.facets[facet];

            if (values && values.length > 0) {
                filtersFound = true;

                values.forEach(value => {
                    let labelText;

                    if (facet === 'blog_author') {
                        labelText = (window.facetData?.authorNames?.[value]) || getFacetDisplayLabel(facet, value);
                    } else {
                        labelText = getFacetDisplayLabel(facet, value);
                    }

                    const span = document.createElement('span');
                    span.className = 'facet-filter-term';
                    span.textContent = `${labelText}`; // Display label
                    span.setAttribute('role', 'button');
                    span.setAttribute('tabindex', '0');
                    span.setAttribute('aria-label', `Remove filter: ${labelText}`);
                    // Keep the raw values for URL surgery
                    span.dataset.facet = facet;
                    span.dataset.value = value;

                    filterContainer?.appendChild(span);

                    // Make entire span clickable to remove the filter
                    span.addEventListener('click', function () {
                        const { facet, value } = span.dataset;

                        // 1) Try the normal path (visible checkbox is present & checked)
                        const targetCheckbox = document.querySelector(
                            `.facetwp-facet-${facet} .facetwp-checkbox[data-value="${value}"]`
                        );

                        if (targetCheckbox && targetCheckbox.classList.contains('checked')) {
                            targetCheckbox.click(); // uncheck just this one
                            FWP.refresh();
                            return;
                        }

                        // 2) Zero-results fallback: remove just this value from the URL param (e.g., _resource_topic)
                        const didChange = removeFacetValueFromUrl(facet, value);

                        // If no change, do nothing—don’t risk nuking other selections
                        if (!didChange) {
                            // Optional: console.warn('Param not found or value not present in URL', facet, value);
                        }
                    });

                    span.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // stop page from scrolling on Space
                            span.click();
                        }
                    });

                });
            }
        });

        // Toggle the wrapper's display
        if (filterWrapper) {
            filterWrapper.style.display = filtersFound ? 'flex' : 'none';
        }

        // ========== EVENT LISTINGS FILTER TERMS (separate from resources) ==========
        populateEventFilterTerms();
    });

    // Function to populate event filter terms (reusable for initial load and facetwp-loaded event)
    // Make it globally accessible so EventListings.js can call it
    window.populateEventFilterTerms = function populateEventFilterTerms() {
        // Only process if we're on event listings page (has .event-listings section)
        const hasEventListings = document.querySelector('.event-listings');
        if (!hasEventListings || typeof FWP === 'undefined') {
            return;
        }

        // Clear previous filter terms
        const filterContainer = document.getElementById('eventsFilterTerms');
        const searchContainer = document.getElementById('eventsSearchTerm');
        
        if (filterContainer) {
            filterContainer.innerHTML = '';
        }
        if (searchContainer) {
            searchContainer.innerHTML = '';
        }

        // Track filters
        let filtersFound = false;
        let searchFound = false;

        // Event facets (single set, no prefix needed)
        const eventFacets = ['events_type', 'events_product', 'events_location', 'events_language'];

        // Helper function to create filter term span (reusable for both sections)
        function createEventFilterTerm(facet, value, container) {
            let labelText = value
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');

            const span = document.createElement('span');
            span.className = 'facet-filter-term';
            span.textContent = labelText;
            span.setAttribute('role', 'button');
            span.setAttribute('tabindex', '0');
            span.setAttribute('aria-label', `Remove filter: ${labelText}`);
            span.dataset.facet = facet;
            span.dataset.value = value;

            // Add close icon SVG after the text
            const closeIconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            closeIconSvg.setAttribute('width', '8');
            closeIconSvg.setAttribute('height', '8');
            closeIconSvg.setAttribute('viewBox', '0 0 8 8');
            closeIconSvg.setAttribute('fill', 'none');
            closeIconSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            
            const closeIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            closeIconPath.setAttribute('d', 'M7.35938 6.30469C7.66406 6.58594 7.66406 7.07812 7.35938 7.35938C7.21875 7.5 7.03125 7.57031 6.84375 7.57031C6.63281 7.57031 6.44531 7.5 6.30469 7.35938L3.84375 4.89844L1.35938 7.35938C1.21875 7.5 1.03125 7.57031 0.84375 7.57031C0.632812 7.57031 0.445312 7.5 0.304688 7.35938C0 7.07812 0 6.58594 0.304688 6.30469L2.76562 3.82031L0.304688 1.35938C0 1.07812 0 0.585938 0.304688 0.304688C0.585938 0 1.07812 0 1.35938 0.304688L3.84375 2.76562L6.30469 0.304688C6.58594 0 7.07812 0 7.35938 0.304688C7.66406 0.585938 7.66406 1.07812 7.35938 1.35938L4.89844 3.84375L7.35938 6.30469Z');
            closeIconPath.setAttribute('fill', '#011F3D');
            
            closeIconSvg.appendChild(closeIconPath);
            span.appendChild(closeIconSvg);

            container.appendChild(span);

            // Make entire span clickable to remove the filter
            span.addEventListener('click', function () {
                const { facet, value } = span.dataset;

                // Try the normal path (visible checkbox is present & checked)
                const targetCheckbox = document.querySelector(
                    `.facetwp-facet-${facet} .facetwp-checkbox[data-value="${value}"]`
                );

                if (targetCheckbox && targetCheckbox.classList.contains('checked')) {
                    targetCheckbox.click(); // uncheck just this one
                    FWP.refresh();
                    return;
                }

                // Zero-results fallback: remove just this value from the URL param
                const didChange = removeFacetValueFromUrl(facet, value);

                if (!didChange) {
                    // Optional: console.warn('Param not found or value not present in URL', facet, value);
                }
            });

            span.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    span.click();
                }
            });
        }

        // Helper function to create search term span (similar to filter terms but for search)
        function createEventSearchTerm(facet, value, container) {
            const span = document.createElement('span');
            span.className = 'facet-filter-term';
            span.textContent = value; // Search terms display as-is, no formatting
            span.setAttribute('role', 'button');
            span.setAttribute('tabindex', '0');
            span.setAttribute('aria-label', `Remove search: ${value}`);
            span.dataset.facet = facet;
            span.dataset.value = value;

            // Add close icon SVG after the text
            const closeIconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            closeIconSvg.setAttribute('width', '8');
            closeIconSvg.setAttribute('height', '8');
            closeIconSvg.setAttribute('viewBox', '0 0 8 8');
            closeIconSvg.setAttribute('fill', 'none');
            closeIconSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            
            const closeIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            closeIconPath.setAttribute('d', 'M7.35938 6.30469C7.66406 6.58594 7.66406 7.07812 7.35938 7.35938C7.21875 7.5 7.03125 7.57031 6.84375 7.57031C6.63281 7.57031 6.44531 7.5 6.30469 7.35938L3.84375 4.89844L1.35938 7.35938C1.21875 7.5 1.03125 7.57031 0.84375 7.57031C0.632812 7.57031 0.445312 7.5 0.304688 7.35938C0 7.07812 0 6.58594 0.304688 6.30469L2.76562 3.82031L0.304688 1.35938C0 1.07812 0 0.585938 0.304688 0.304688C0.585938 0 1.07812 0 1.35938 0.304688L3.84375 2.76562L6.30469 0.304688C6.58594 0 7.07812 0 7.35938 0.304688C7.66406 0.585938 7.66406 1.07812 7.35938 1.35938L4.89844 3.84375L7.35938 6.30469Z');
            closeIconPath.setAttribute('fill', '#011F3D');
            
            closeIconSvg.appendChild(closeIconPath);
            span.appendChild(closeIconSvg);

            container.appendChild(span);

            // Make entire span clickable to remove the search term
            span.addEventListener('click', function () {
                const { facet } = span.dataset;

                // Clear the search input if it exists
                const searchInput = document.querySelector(`.facetwp-facet-${facet} input[type="text"]`);
                if (searchInput) {
                    searchInput.value = '';
                }

                // Remove from URL params
                const urlKey = `_${facet}`;
                const url = new URL(window.location.href);
                const params = url.searchParams;

                if (params.has(urlKey)) {
                    params.delete(urlKey);
                    // Also clear paging
                    params.delete('fwp_paged');
                    params.delete('paged');
                    url.search = params.toString();
                    window.location.href = url.toString();
                } else {
                    // If not in URL, try to clear via FacetWP
                    if (FWP.facets && FWP.facets[facet]) {
                        FWP.facets[facet] = '';
                        FWP.refresh();
                    }
                }
            });

            span.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    span.click();
                }
            });
        }

        // Get values from both FWP.facets AND URL params (URL params are source of truth)
        const urlParams = new URLSearchParams(window.location.search);
        
        // Process event facets (single set)
        eventFacets.forEach(facet => {
            // Check URL params first (source of truth)
            const urlKey = `_${facet}`;
            let values = [];
            
            if (urlParams.has(urlKey)) {
                const urlValue = urlParams.get(urlKey);
                if (urlValue) {
                    values = urlValue.split(',').filter(v => v.trim() !== '');
                }
            } else if (FWP.facets && FWP.facets[facet]) {
                // Fallback to FWP.facets if not in URL
                values = Array.isArray(FWP.facets[facet]) ? FWP.facets[facet] : [FWP.facets[facet]];
            }
            
            if (values.length > 0 && filterContainer) {
                filtersFound = true;
                values.forEach(value => {
                    createEventFilterTerm(facet, value.trim(), filterContainer);
                });
            }
        });

        // Process search terms
        const searchFacet = 'events_search';
        const urlKeySearch = `_${searchFacet}`;
        let searchValue = '';
        
        if (urlParams.has(urlKeySearch)) {
            searchValue = urlParams.get(urlKeySearch);
        } else if (FWP.facets && FWP.facets[searchFacet]) {
            // Ensure it's a string (search facets can be strings or arrays)
            const value = FWP.facets[searchFacet];
            searchValue = Array.isArray(value) ? value.join(' ') : String(value || '');
        }
        
        // Ensure it's a string before calling trim
        searchValue = String(searchValue || '').trim();
        if (searchValue !== '' && searchContainer) {
            searchFound = true;
            createEventSearchTerm(searchFacet, searchValue, searchContainer);
        }

        // Toggle display of filter term containers
        if (filterContainer) {
            filterContainer.style.display = filtersFound ? 'flex' : 'none';
            
            // Hide the previous sibling .facetwp-facet .facetwp-reset if filter terms are hidden
            const resetButton = filterContainer.previousElementSibling?.querySelector('.facetwp-reset');
            if (resetButton) {
                resetButton.style.display = filtersFound ? '' : 'none';
            }
        }

        // Toggle display of search term container
        if (searchContainer) {
            searchContainer.style.display = searchFound ? 'flex' : 'none';
            
            // Hide the previous sibling .facetwp-facet .facetwp-reset if search term is hidden
            const searchResetButton = searchContainer.previousElementSibling?.querySelector('.facetwp-reset');
            if (searchResetButton) {
                searchResetButton.style.display = searchFound ? '' : 'none';
            }
        }
    }

    // Populate filter terms on initial page load if URL params exist
    // Wait for FacetWP to initialize and parse URL params
    function initEventFilterTerms() {
        const hasEventListings = document.querySelector('.event-listings');
        if (!hasEventListings) {
            return;
        }

        // Check if URL has event filter params
        const urlParams = new URLSearchParams(window.location.search);
        let hasEventParams = false;
        for (const [key] of urlParams.entries()) {
            const cleanKey = key.replace(/^_/, '');
            if (cleanKey.indexOf('events_') === 0 || cleanKey === 'event_status') {
                hasEventParams = true;
                break;
            }
        }

        if (hasEventParams) {
            // Wait for FacetWP to be ready and parse URL params
            const checkFacetWP = setInterval(() => {
                if (typeof FWP !== 'undefined' && FWP.facets) {
                    clearInterval(checkFacetWP);
                    // Small delay to ensure URL params are parsed
                    setTimeout(populateEventFilterTerms, 100);
                }
            }, 50);

            // Timeout after 2 seconds
            setTimeout(() => {
                clearInterval(checkFacetWP);
            }, 2000);
        }
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initEventFilterTerms);
    } else {
        initEventFilterTerms();
    }
    // ========== END EVENT LISTINGS FILTER TERMS ==========

    // loader things to prevent showing flashing of unstyled content while facet is loading content
    jQuery(document).on('facetwp-refresh', function() {
        // Show loader on the template container
        jQuery('.archive-listing').addClass('facetwp-loading');
    });

    jQuery(document).on('facetwp-loaded', function() {
        // Hide loader after loading is complete
        jQuery('.archive-listing').removeClass('facetwp-loading');
    });
    
}

export { init as default };
